export default __webpack_public_path__ + "static/media/logo_white.552af283.svg";